/* src/app/modules/members/member-admincontrol/member-admincontrol.component.scss */
.filter-form .mat-mdc-form-field {
  padding: 5px;
}
.filterbox {
  padding: 10px;
}
/*# sourceMappingURL=member-admincontrol.component.css.map */
